/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    
    interface IDualListModalObject {
        id: any;
        name: string;
        secondaryInfo: string;
        logo: string;
    }
    export interface IDualListModalScope extends ng.IScope {
        title: string;
        titleElements: string;
        titleSelectedElements: string;
        firstColumn: string;
        secondColumn: string;
        secondaryInfoCompare: string;
        selectedElements: IDualListModalObject[];
        elements: IDualListModalObject[];
        highlightedId: number;
        noMoreToAddText: string;
        noneSelectedText: string;
        type: string;
        modalSave: () => void;
        modalClose: () => void;
        close: (result: Object) => void;
        elementsSearch: { 
            name: string; 
        };
        selectedElementsSearch: {
            name: string;
        };

        select: (element: Object) => void;
        unselect: (element: Object) => void;
        selectAll: () => void;
        unselectAll: () => void;
        getSelected: () => Object[];
        getAll: () => Object[];
    }
    
    /**
     * DualListModalController class
     */
    export class DualListModalController {
        public static ID: string = "#dual-list-modal";
        public static $name: string = "dualListModalController";
        public static templateUrl: string = "decorators/modals/dual-list-modal.html";
        public static userType: string = "USER";
        public static vnoType: string = "VNO";
        public static blockType: string = "BLOCK";
        
        public static $inject: string[] = [
            '$scope',
            'close',
            'title',
            'titleElements',
            'titleSelectedElements',
            'firstColumn',
            'secondColumn',
            'secondaryInfoCompare',
            'selectedElements',
            'elements',
            'highlightedId',
            'idProperty',
            'nameProperty',
            'secondColumnProperty',
            'noMoreToAddText',
            'noneSelectedText',
            'type'];

        private $scope: IDualListModalScope;
        private close: (result: { selected: Object[], unselected: Object[] }) => void;

        /**
         * Constructor
         */
        constructor($scope: IDualListModalScope,
                    close: (result: { selected: Object[], unselected: Object[] }) => void,
                    title: string,
                    titleElements: string,
                    titleSelectedElements: string,
                    firstColumn: string,
                    secondColumn: string,
                    secondaryInfoCompare: string,
                    selectedElements: Object[],
                    elements: Object[],
                    highlightedId: number,
                    idProperty: string,
                    nameProperty: string,
                    secondColumnProperty: string,
                    noMoreToAddText: string,
                    noneSelectedText: string,
                    type: string) {
            this.$scope = $scope;
            this.$scope.title = title;
            this.$scope.titleElements = titleElements;
            this.$scope.titleSelectedElements = titleSelectedElements;
            this.$scope.firstColumn = firstColumn;
            this.$scope.secondColumn = secondColumn;
            this.$scope.secondaryInfoCompare = secondaryInfoCompare;
            this.$scope.selectedElements = selectedElements.map((object: Object) => {
                return {
                    id: DualListModalController.getProperty(object,idProperty),
                    name: DualListModalController.getProperty(object,nameProperty),
                    secondaryInfo: DualListModalController.getProperty(object, secondColumnProperty),
                    logo: this.getLogo(object, type),
                };
            });
            this.$scope.elements = elements.map((object: Object) => {
                return {
                    id: DualListModalController.getProperty(object,idProperty),
                    name: DualListModalController.getProperty(object,nameProperty),
                    secondaryInfo: DualListModalController.getProperty(object, secondColumnProperty),
                    logo: this.getLogo(object, type),
                };
            });
            this.$scope.highlightedId = highlightedId;
            this.$scope.noMoreToAddText = noMoreToAddText;
            this.$scope.noneSelectedText = noneSelectedText;

            this.$scope.select = (element: IDualListModalObject): void => {
                this.removeElement(this.$scope.elements, element);
                this.$scope.selectedElements.push(element);
            };

            this.$scope.unselect = (element: IDualListModalObject): void => {
                this.$scope.elements.push(element);
                this.removeElement(this.$scope.selectedElements, element);
            };

            this.$scope.selectAll = () => {
                let filterString: string = this.$scope.elementsSearch ? this.$scope.elementsSearch.name.toLowerCase() : '';
                this.$scope.elements.filter((element: IDualListModalObject) => {
                    return element.name.toLowerCase().indexOf(filterString) !== -1;
                }).forEach((element: IDualListModalObject) => {
                    this.$scope.select(element);
                });
            };

            this.$scope.unselectAll = () => {
                let filterString: string = this.$scope.selectedElementsSearch ? this.$scope.selectedElementsSearch.name.toLowerCase() : '';
                this.$scope.selectedElements.filter((element: IDualListModalObject) => {
                    return element.name.toLowerCase().indexOf(filterString) !== -1;
                }).forEach((element: IDualListModalObject) => {
                    this.$scope.unselect(element);
                });
            };

            this.close = close;
            
            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = () => {
                const selectedNow: Object[] = [];
                const unselectedNow: Object[] = [];
                elements.concat(selectedElements).forEach((object: Object) => {
                    let isSelected: boolean = this.$scope.selectedElements.some((selectedElement: IDualListModalObject) => {
                        return selectedElement.id === DualListModalController.getProperty(object, idProperty);
                    });
                    let isUnselected: boolean = this.$scope.elements.some((element: IDualListModalObject) => {
                        return element.id === DualListModalController.getProperty(object, idProperty);
                    });
                    if (isSelected) {
                        selectedNow.push(object);
                    } else if (isUnselected) {
                        unselectedNow.push(object);
                    }
                });
                this.close({
                    selected: selectedNow,
                    unselected: unselectedNow,
                });
            };
        }

        private removeElement(elements: IDualListModalObject[], element: IDualListModalObject): void {
            let indexFound: number = -1;
            for (let i: number = 0; i < elements.length ; i++) {
                if (elements[i].id === element.id)
                    indexFound = i;
            }
            if (indexFound > -1) {
                elements.splice(indexFound, 1);
            }
        }

        private getLogo(object: Object, type: String): string{
            let typeString = 'type';
            let logo: string = undefined;
            switch (type) {
                case DualListModalController.userType:
                    logo = "perm_identity";
                break;
                case DualListModalController.vnoType:
                    logo = "location_city";
                break;
                case DualListModalController.blockType:
                    if (object.hasOwnProperty(typeString)) {
                        if (object[typeString] === 'destination') {
                            logo = 'add_to_queue';
                        }
                        else if (object[typeString] === 'source') {
                            logo = 'video_call';
                        }
                    } else {
                        logo = 'cast';
                    }
                break;
                default:
            }
            return logo;
        }

        private static getProperty(object: Object, propertyPath: string): any {
            if (propertyPath) {
                return DualListModalController.getPropertyPath(object, propertyPath.split("."));
            } else {
                return undefined;
            }
        }

        private static getPropertyPath(object: Object, propertyPath: string[]): any {
            let currentObject: any = object;
            let index: number = 0;
            while(currentObject !== undefined && index < propertyPath.length ) {
                const property = propertyPath[index];
                currentObject = currentObject[property];
                index++;
            }
            return currentObject;
        }
    }

}
